export const podcastData = [
	{
		id: 1,
		title: "Episode 1: Life as a Nigerian University Student",
		desc: "Join us as we take a trip down memory lane and reminisce about our first day of school. From the nerves of writing WAEC and going through JAMB processes to the POST-UTME palava, we shared our experiences and reflections.",
		date: "June 23, 2023",
		time: "60 mins",
		tags: "Student, Finalist, Nigerian University",
		platform: "Apple Podcast, Spotify",
		link: "https://open.spotify.com/episode/3vZ7GKnXZksblsXXITDXD9?si=OvUysgvrToKk8Ei65YWCqg",
	},
  {
		id: 2,
		title: "Episode 2: Okùnrin",
		desc: "Get ready for an exciting journey as we dive into the heart of masculinity in our latest episode, 'Okùnrin.'",
		date: "September 8, 2023",
		time: "35 mins",
		tags: "Men, Boy, Guy, Odogwu",
		platform: "Apple Podcast, Spotify",
		link: "https://open.spotify.com/episode/4MP840xMl2T1ijAyir8ldE?si=BBCDFmdXR66-fezXEtZNKA",
	},
]